import { Select } from "antd"
import React from "react"

export const HourSelector = (props: any) => {
    return <>
        <Select value={props.hours} loading={props.loading}
            onChange={(value, option) => {
                props.onHourChange(value)
            }}
            options={[
                {
                    label: "2 hours",
                    value: 2,
                },
                {
                    label: "4 hours",
                    value: 4,
                },
                {
                    label: "8 hours",
                    value: 8,
                },
                {
                    label: "12 hours",
                    value: 12,
                },
            ]} />
    </>
}
